/**
 * Move image from primary content to secondary content in icon cards
 * 
 * Moves .e-img from .e-div--expanding-card-primary-content
 * to .e-div--expanding-card-secondary-content
 * within .e-stn--icon-cards-with-hover-and-bottom-cta
 * 
 * On screens 1199px and below, appends the image to the top of <a> tag if it exists
 */
( function() {
  'use strict';

  const MAX_WIDTH = 1199;

  const isMobileView = () => {
    return window.innerWidth <= MAX_WIDTH;
  };

  const moveImageToLink = ( image, linkTag ) => {
    linkTag.insertBefore( image, linkTag.firstChild );
  };

  const appendImageToContent = ( image, secondaryContent ) => {
    secondaryContent.appendChild( image );
  };

  const processCard = ( card ) => {
    const primaryContent = card.querySelector( '.e-div--expanding-card-primary-content' );
    const secondaryContent = card.querySelector( '.e-div--expanding-card-secondary-content' );
		
    if ( !primaryContent || !secondaryContent ) return;
		
    const image = primaryContent.querySelector( '.e-img' );
    if ( !image ) return;

    const linkTag = secondaryContent.querySelector( 'a' );
		
    if ( linkTag ) {
      moveImageToLink( image, linkTag );
    } else {
      appendImageToContent( image, secondaryContent );
    }
  };

  const processSection = ( section ) => {
    const cards = section.querySelectorAll( '.e-div--expanding-card' );
    cards.forEach( processCard );
  };

  const moveImageToSecondaryContent = () => {
    if ( !isMobileView() ) return;

    const sections = document.querySelectorAll( '.e-stn--icon-cards-with-hover-and-bottom-cta' );
    sections.forEach( processSection );
  };

  const init = () => {
    moveImageToSecondaryContent();
  };

  if ( document.readyState === 'loading' ) {
    document.addEventListener( 'DOMContentLoaded', init );
  } else {
    init();
  }

  let resizeTimeout;
  window.addEventListener( 'resize', () => {
    clearTimeout( resizeTimeout );
    resizeTimeout = setTimeout( () => {
      if ( isMobileView() ) {
        moveImageToSecondaryContent();
      }
    }, 250 );
  } );
}() );

